import React from 'react';

import {SvgProps} from '../../helpers/type';

const Calendar = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.712256"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M19.9664 21.8556H18.0775V23.7444H19.9664V21.8556ZM23.7442 21.8556H21.8553V23.7444H23.7442V21.8556ZM27.522 21.8556H25.6331V23.7444H27.522V21.8556ZM29.4109 15.2444H28.4664V13.3556H26.5775V15.2444H19.022V13.3556H17.1331V15.2444H16.1886C15.1403 15.2444 14.3092 16.0944 14.3092 17.1333L14.2997 30.3556C14.2997 31.3944 15.1403 32.2444 16.1886 32.2444H29.4109C30.4497 32.2444 31.2997 31.3944 31.2997 30.3556V17.1333C31.2997 16.0944 30.4497 15.2444 29.4109 15.2444ZM29.4109 30.3556H16.1886V19.9667H29.4109V30.3556Z"
                fill="#5D847F"
            />
            <rect
                x="0.712256"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default Calendar;
